// Generated by ReScript, PLEASE EDIT WITH CARE

import PackageJson from "/package.json";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as GlobalVars$OrcaPaymentPage from "./GlobalVars.bs.js";

function querySelectorAllArray(selector) {
  return Array.from(document.querySelectorAll(selector));
}

let Navigator = {};

let Location = {};

let Location$1 = {};

let Top = {
  Location: Location$1
};

let LocalStorage = {};

let Element = {};

function sendPostMessage(element, message) {
  element.postMessage(JSON.stringify(message), GlobalVars$OrcaPaymentPage.targetOrigin);
}

function sendPostMessageJSON(element, message) {
  element.postMessage(message, GlobalVars$OrcaPaymentPage.targetOrigin);
}

function iframePostMessage(iframeRef, message, targetOriginOpt) {
  let targetOrigin = targetOriginOpt !== undefined ? targetOriginOpt : GlobalVars$OrcaPaymentPage.targetOrigin;
  if (iframeRef == null) {
    console.error("This element does not exist or is not mounted yet.");
    return;
  }
  try {
    iframeRef.contentWindow.postMessage(JSON.stringify(message), targetOrigin);
    return;
  } catch (exn) {
    return;
  }
}

let version = PackageJson.version;

let hrefWithoutSearch = window.location.origin + window.location.pathname;

function isIframed() {
  try {
    return window.location.href !== window.top.location.href;
  } catch (raw_e) {
    let e = Primitive_exceptions.internalToException(raw_e);
    console.error("Failed to check whether or not document is within an iframe", e, `Using "` + String(true) + `" as default (due to DOMException)`);
    return true;
  }
}

function getRootHostName() {
  if (!isIframed()) {
    return window.location.hostname;
  }
  try {
    return window.top.location.hostname;
  } catch (raw_e) {
    let e = Primitive_exceptions.internalToException(raw_e);
    let $$default = window.location.hostname;
    console.error("Failed to get root document's hostname", e, `Using "` + $$default + `" [window.location.hostname] as default`);
    return $$default;
  }
}

export {
  querySelectorAllArray,
  Navigator,
  Location,
  Top,
  LocalStorage,
  Element,
  sendPostMessage,
  sendPostMessageJSON,
  iframePostMessage,
  version,
  hrefWithoutSearch,
  isIframed,
  getRootHostName,
}
/* version Not a pure module */
